import {bymoTemplateMetadataFactoryCreate} from '../../../doppe-sdk';
import type {DoppeDtoAction} from '../../../client-server-common/types/doppe-dto-action';
import type {
    DoppeBymoPageActionPreviewSettings,
    DoppeBymoPageActionsDividerSettings
} from '../../../client-server-common';

export namespace BymoTemplateActionPreview {

    export interface TemplateProps {
        enableContentScrolling: boolean;
        actionsDivider: DoppeBymoPageActionsDividerSettings | null;
        defaultActionPreviewSettings: DoppeBymoPageActionPreviewSettings | null;
        actionsPreviewSettings: Record<DoppeDtoAction.Id, DoppeBymoPageActionPreviewSettings>;
        scaledContentTrimmingSettings: {
            maxContentHeight: number;
            easingGradientOverlayColor: string;
        } | null;
    }
}

const initialValues = {
    enableContentScrolling: true,
    actionsDivider: null,
    actionsPreviewSettings: {},
    defaultActionPreviewSettings: null,
    scaledContentTrimmingSettings: null
} as BymoTemplateActionPreview.TemplateProps;

export const BymoTemplateActionPreviewTemplateMetadata = bymoTemplateMetadataFactoryCreate<BymoTemplateActionPreview.TemplateProps>()({
    initialValues: initialValues,
    resolveProps: (props) => {
        return {
            ...initialValues,
            ...props
        }
    },
    templatePropsMetadata: {},
    features: ['hasActions', 'hasActionButton']
})